// Shared utilities and types for DataTable and its subcomponents

export interface Action {
  name: "edit" | "delete" | "view" | "search" | string;
  handler?: (row: any, rowIndex?: number) => void;
  render?: (data?: any, rowIndex?: number) => React.ReactNode;
  onCheck?: (data: any) => void;
  icon?: any;
}

export type TableSize = "default" | "compact" | "large";

export type SortDirection = "asc" | "desc" | null;

export interface SortConfig {
  key: string | null;
  direction: SortDirection;
}

export const tableSizeConfigs: Record<
  TableSize,
  {
    containerClass: string;
    maxHeight: string;
    headerClass: string;
    cellClass: string;
    buttonSize: "xs" | "sm" | "default";
  }
> = {
  default: {
    containerClass: "rounded-xl border border-gray-200  shadow-sm bg-white overflow-hidden",
    maxHeight: "max-h-[77vh]",
    headerClass: "px-4 py-3 text-left font-semibold text-muted-foreground",
    cellClass: "px-4 py-3",
    buttonSize: "sm",
  },
  compact: {
    containerClass: "rounded border border-gray-200 shadow-sm bg-white",
    maxHeight: "max-h-[45vh]",
    headerClass: "px-2 py-1.5 text-left font-medium text-muted-foreground text-xs leading-tight",
    cellClass: "px-2 py-1.5 text-xs leading-tight",
    buttonSize: "xs",
  },
  large: {
    containerClass: "rounded-xl border border-gray-200 shadow-lg bg-white",
    maxHeight: "max-h-[90vh]",
    headerClass: "px-6 py-4 text-left font-bold text-muted-foreground text-base",
    cellClass: "px-6 py-4 text-base",
    buttonSize: "default",
  },
};

/**
 * Normalize a header label to a key used for sorting or accessing data.
 * Falls back to lowercased, whitespace-stripped header when a mapping is not found.
 */
export function getHeaderKey(header: string | number, index: number): string {
  if (typeof header === "number") return String(header);
  const fieldMappings: Record<string, string> = {
    client: "client",
    contact: "contact",
    "insurance type": "insuranceType",
    insuranceType: "insuranceType",
    status: "status",
    "last contact": "lastContact",
    lastContact: "lastContact",
    "assigned to": "assignedTo",
    assignedTo: "assignedTo",
    name: "name",
    email: "email",
    phone: "phone",
    date: "date",
    amount: "amount",
    type: "type",
    id: "id",
  };

  const lowerHeader = String(header).toLowerCase().trim();
  return fieldMappings[lowerHeader] || lowerHeader.replace(/\s+/g, "");
}
